import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IPharmacySuppliers } from 'app/shared/model/pharmacy-suppliers.model';
import { ITenantEmployee } from 'app/shared/model/tenant-employee.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';

export interface IPharmacyStockBill {
  id?: string;
  billNumber?: string | null;
  billDate?: number | null;
  totalCost?: number | null;
  discount?: number | null;
  active?: boolean | null;
  cursor?: number;
  timestampentry?: number | null;
  microSec?: number | null;
  lastupdated?: number | null;
  cgst?: number | null;
  sgst?: number | null;
  roundOffVal?: number | null;
  shipmentId?: string | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  margin?: number | null;
  cessAmount?: number | null;
  amended?: boolean | null;
  statusDate?: number | null;
  receivedDate?: number | null;
  pharmacy?: IPharmacy | null;
  pharmacySuppliers?: IPharmacySuppliers | null;
  pharmacist?: ITenantEmployee | null;
  amendedFrom?: IPharmacyStockBill | null;
  amendedTo?: IPharmacyStockBill | null;
  invoiceType?: IClinicalDictionary | null;
  approvalStatus?: IClinicalDictionary | null;
  statusSettingPharmacy?: IPharmacy | null;
}

export const defaultValue: Readonly<IPharmacyStockBill> = {
  active: false,
  amended: false,
};
